<template>
  <div>
    <button class="btn btn-sm btn-primary" @click="openModal">
      {{ label }}
    </button>

    <!-- モーダル -->
    <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">エントリークラスを選択</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <div v-if="loading">
              <p class="text-center">読み込み中...</p>
              <div class="text-center">
                <div class="spinner-border" role="status"></div>
              </div>
            </div>

            <div v-else-if="entryOptions.length > 0">
              <p class="mb-3">以下からエントリークラスを選択してください</p>
              <div class="row pt-3 border-top" v-for="option in entryOptions" :key="option.id" >
                <div class="col-12 mb-2">
                  <h5 v-html="option.class_name"></h5>
                </div>
                <div class="col-12">
                  <div class="d-grid gap-2" v-if="option.is_matched==1">
                    <button
                      class="btn btn-outline-primary"
                      @click="goToOption(option)"
                    >エントリーできます
                    </button>
                  </div>
                  <div v-else-if="option.is_matched==0">
                    <p class="alert alert-warning alert-sm">所持しているライセンスではエントリーできません。</p>
                    <div class="d-grid gap-2">
                      <button
                        class="btn btn-outline-primary"
                        @click="goToOption(option)"
                      >所持ライセンスではエントリーできませんが、別ライセンスであればエントリーできます。
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="race_data_url">
              <p class="text-muted">詳しくは主催者の<a :href="race_data_url" target="_blank">公式サイト</a>からご確認ください。</p>
            </div>
            <div v-else>
              <p class="text-muted">詳しくは主催者の公式サイトからご確認ください。</p>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="closeModal">閉じる</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, ref } from 'vue'
import config from '../../../const'
import axios from 'axios'
const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  race_data_cd: {
    type: String,
    required: true,
  },
  race_data_seq: {
    type: String,
    required: true,
  },
  user_token: {
    type: String,
    required: true,
  },
  race_data_url: {
    type: String
  },
  member_license: {
    type: Array,
  },
  loadMseventTokenObj: {
    type: Function,
    required: true,
  },
})

const showModal = ref(false)
const loading = ref(false)
const entryOptions = ref([])
const token = ref('')

const baseUrl = computed(() => {
  const env = process.env.VUE_APP_ENV
  if (env === 'production') {
    return config.SSO_SITE_URL
  } else if (['staging', 'mfj'].includes(env)) {
    return 'https://staging.ms-event.net'
  } else if (env === 'sandbox') {
    return 'https://sandbox.ms-event.net'
  } else if (env === 'development') {
    return 'https://local7.ms-event.net:8443'
  } else {
    return config.SSO_SITE_URL
  }
})
console.log(baseUrl)

const openModal = async () => {
  showModal.value = true
  loading.value = true
  entryOptions.value = []

  try {
    token.value = await fetchTokenFromServer()
    await fetchEntryOptions()
  } catch (e) {
    // alert('エントリー情報の取得に失敗しました\n' + e.message)
  } finally {
    loading.value = false
  }
}

const fetchTokenFromServer = async () => {
  const result = await props.loadMseventTokenObj()
  if (result?.status === 200 && result?.data?.body?.token) {
    return result.data.body.token
  }
  throw new Error('SSOトークン取得に失敗しました。')
}

const fetchEntryOptions = async () => {

  const params = new URLSearchParams()
  params.append('sprm[race_data_cd]', props.race_data_cd)
  params.append('sprm[race_data_seq]', props.race_data_seq)
  if(Array.isArray(props.member_license) && props.member_license.length > 0){
    params.append('sprm[member_license]', JSON.stringify(props.member_license))
  }
  params.append('sprm[target_date]', 'now')
  const result = await axios
    .post(
      config.BASE_API_URL + '/member/mseventraceclass',
      // this.setParams_S(params),
      params,
       { headers: {[config.BASE_API_USER_HEADER_KEY]: props.user_token} }
    )
    .then(async (response) => {
      return (response?.data?.body?.response)? response?.data?.body?.response: false
    })
    .catch(async (err) => {
      // console.log('globalActionsTest basicPosts err', err);
      throw err
    })
    .finally(async () => {
      // console.log('globalActionsTest basicPosts finally');
      // return true;
    })
    console.log('result', result)
    entryOptions.value = result
  if (!entryOptions?.value) {
    throw new Error('オプションデータが取得できませんでした。')
  }
}

const closeModal = () => {
  showModal.value = false
}

const goToOption = async (option) => {
  let baseUrl
  switch (process.env.VUE_APP_ENV) {
    case 'production':
      baseUrl = config.SSO_SITE_URL
      break
    case 'staging':
    case 'mfj':
      baseUrl = 'https://staging.ms-event.net'
      break
    case 'sandbox':
      baseUrl = 'https://sandbox.ms-event.net'
      break
    case 'development':
      baseUrl = 'https://local7.ms-event.net:8443'
      break
    default:
      baseUrl = config.SSO_SITE_URL
  }
  if (!baseUrl) {
    throw new Error('コンフィグが未設定です。' + '.' + config.BASE_SERVICE_URL)
  }


  try {
    const token = await fetchTokenFromServer()

    const url = new URL(baseUrl)
    console.log('url+', baseUrl)
    url.pathname += config.MSEVENT_COMPANY_KEY + '/user/'
    url.searchParams.set('a', 'login.user_token_login')
    url.searchParams.set('org_token', token)
    if(typeof option === 'object' && option?.race_class_relation_id){
      url.searchParams.set('target', option?.race_class_relation_id)
    }
    console.log('url', url.toString)
    // alert(url.toString())
    window.open(url.toString(), '_blank');
    // window.location.href = 

  } catch (e) {
    // alert('エントリー情報の取得に失敗しました\n' + e.message)
  } finally {
    loading.value = false
    showModal.value = false
  }
  // if (option.url) {
  //   window.open(option.url, '_blank')
  //   showModal.value = false
  // }
}
</script>
